module.exports = __webpack_public_path__ + "img/_3.f329fcc8.png";